import MyProfile from '../../components/MyProfile'

export const MyProfilePage =()=><MyProfile/>

export default MyProfilePage